import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/AdjustDebitsFoodCourts/Get`, payload),
    GetById: (payload) => Repository.post(`/api/AdjustDebitsFoodCourts/GetById`, payload),
    Add: (payload) => Repository.post(`/api/AdjustDebitsFoodCourts/Add`, payload),
    Edit: (payload) => Repository.post(`/api/AdjustDebitsFoodCourts/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/AdjustDebitsFoodCourts/Delete`, payload),
}
